var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-top"},[_c('div',{staticClass:"center-item"},[_c('div',{staticClass:"icon",style:({
					backgroundImage: ("url(" + (require('../assets/home/qiwen.png')) + ")"),
				})}),_c('div',{staticClass:"item-info"},[_vm._v("21°")])]),_c('div',{staticClass:"center-item"},[_c('div',{staticClass:"icon",style:({
					backgroundImage: ("url(" + (require('../assets/home/qing.png')) + ")"),
				})}),_c('div',{staticClass:"item-info"},[_vm._v("白天")])]),_c('div',{staticClass:"center-item"},[_c('div',{staticClass:"icon",style:({
					backgroundImage: ("url(" + (require('../assets/home/time.png')) + ")"),
				})}),_c('div',{staticClass:"item-info"},[_vm._v(_vm._s(_vm.currentTime))])])])}
var staticRenderFns = []

export { render, staticRenderFns }